export default [
    {
        comment: '',
        error_id: 'XY 03',
        data: [
            {cross_section: '4420', ratio: 0.89, xs_len: 89, sta_len: 100},
            {cross_section: '5505', ratio: 1.04, xs_len: 104, sta_len: 100},
        ]
    },
    {
        comment: 'use . instead of : at the end of the sentence',
        error_id: 'XY 04',
        data: [
            {cross_section: '4420'},
            {cross_section: '5505'},
        ]
    }
]